// extracted by extract-css-chunks-webpack-plugin
module.exports = {"form":"form___3kMbH","row":"row___215hf","full":"full___rWTJ5","half":"half___1djl2"};